import PairingStatus from './pairing-status';

export default PairingStatus;
